// extracted by mini-css-extract-plugin
module.exports = {"containerSpacing":"Studio_containerSpacing__Hj0xH"};